export const TEST_ID = 'serviceIntervalModelSelector';

export const LABEL_TEST_ID = 'serviceIntervalModelSelectorLabel';
